import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

class SEO extends React.Component {
  render () {
    return (
         <HelmetProvider>

            <Helmet>
                <meta charSet="utf-8" />
                <title>{this.props.title}</title>
                <link rel="canonical" href={this.props.url} />
				<meta name="description" content={this.props.description} />
				
				<meta property="og:title" content={this.props.title} />
				<meta property="og:image" content={this.props.thumbnail} />
				<meta property="og:url" content={this.props.url} />
            </Helmet>            

	 </HelmetProvider>
    );
  }
};
export default SEO